import MarionetteWrapper from "app/components/marionette-wrapper-for-react";
import Backbone from "backbone";
import metaStoreService from "core/services/metaStoreService/meta-store-service";
import $ from "jquery";
import { createTimeSeriesDataStore } from "src/generic/graphs/time-series-graph/time-series-data.store";
import PreviewPaneCQVisual from "src/modules/flow-designer/preview-pane/preview-pane-cq-visual";
import _ from "underscore";
import PreviewStreamDataLoader from "./previewStreamDataLoader";
import template from "./templates/previewDataTemplate.html";

export default Backbone.Marionette.LayoutView.extend({
    template: _.template(template),
    regions: {
        previewTable: ".preview-table"
    },
    ui: {
        closeButton: "#closeButton",
        fullScreen: "#fullScreen",
        refresh: "#refresh",
        table: "table",
        header: ".header",
        tableWrapper: ".preview-table",
        loader: "div.loader",
        loaderIcon: "div.loader .icon"
    },

    events: {
        "click @ui.closeButton": "onCloseClick",
        "click @ui.refresh": "onRefreshClick",
        "click @ui.fullScreen": "onFullScreenClick"
    },

    _bufferSize: 100,
    _isInFullscreenMode: false,
    _fields: [],
    _renderedData: [],
    initialize: function() {
        var that = this;
        let streamFQN = this.model.metaObject.get("id");
        if (this.model.metaObject.type === metaStoreService.entities.CQ) {
            streamFQN = this.model.metaObject.get("output");
        }
        this.streamFQN = streamFQN;
        this.streamDataLoader = new PreviewStreamDataLoader(streamFQN);

        this.listenTo(this.streamDataLoader, "onDataLoaded", function(data) {
            if (that.model.metaObject.type === metaStoreService.entities.STREAM) {
                that.renderRow(data);
            }
            if (that.model.metaObject.type === metaStoreService.entities.CQ) {
                // this.renderGraph();
                this.renderGraphEntry(data);
            }
        });
    },

    onRender: function() {
        if (this.model.metaObject.type === metaStoreService.entities.STREAM) {
            this.renderTable();
        }
        if (this.model.metaObject.type === metaStoreService.entities.CQ) {
            this.lineChartStore = createTimeSeriesDataStore([]);
            this.renderGraph();
        }
    },

    renderTable: function() {
        var _this = this;
        _this._fields = [];
        metaStoreService.findById(this.streamFQN).then(function(stream) {
            if (!stream.dataType) {
                return;
            }
            metaStoreService.findById(stream.dataType).then(function(type) {
                if (!type || !type.fields) {
                    return;
                }
                _this.dataType = type;
                var $headerRow = _this.ui.table.find("thead>tr");
                $headerRow.append(
                    $("<th>&nbsp;</th>", {
                        class: "header-cell"
                    })
                );
                _.each(type.fields, function(field) {
                    $headerRow.append($("<th></th>").text(field.name));
                    _this._fields.push(field.name);
                });
                _this.startQueryingForData();
            });
        });
    },

    renderGraph: function() {
        const height = this._isInFullscreenMode ? 500 : 240;
        const graphView = MarionetteWrapper(PreviewPaneCQVisual, { store: this.lineChartStore, height });
        this.getRegion("previewTable").show(graphView);

        this.startQueryingForData();
    },

    startQueryingForData: function() {
        this.streamDataLoader.start();
    },
    renderGraphEntry: function(data) {
        if (!this.keyForPredictionOutput) {
            for (let key in data) {
                const val = data[key];
                if (val?.actualValue) {
                    this.keyForPredictionOutput = key;
                    break;
                }
            }
            return;
        }
        const val = data[this.keyForPredictionOutput];
        this.lineChartStore.addDataPoint({
            timestamp: val.currentTimestamp,
            actualValue: val.actualValue,
            predictedValue: val.predictedValue,
            isAnomaly: val.isAnomaly
        });
        // this.lineChartStore.addEntry(data);
    },

    renderRow: function(data) {
        var isDuplicate = _.some(this._renderedData, function(renderedRow) {
            const hasTheSameTimeStamp = renderedRow.timeStamp === data.timeStamp;
            const hasTheSameData = renderedRow.data && data.data && _.isEqual(renderedRow.data, data.data);

            return hasTheSameTimeStamp && hasTheSameData;
        });

        if (isDuplicate) {
            return;
        }

        var $tbody = this.$el.find("tbody");
        var $tr = $("<tr>");
        var id = $tbody.children().length + 1;
        $tr.append("<td>" + id + "</td>");
        _.each(this._fields, function(field) {
            if (_.isObject(data[field]) || _.isArray(data[field])) {
                data[field] = JSON.stringify(data[field]);
            }
            $tr.append("<td>" + data[field] + "</td>");
        });

        $tbody.prepend($tr);

        // store the rendered data for duplicate detection
        this._renderedData.unshift(data);

        // keep only the last _bufferSize entries
        if (this._renderedData.length > this._bufferSize) {
            this._renderedData.pop();
        }
    },

    onBeforeDestroy: function() {
        this.streamDataLoader.stop();
    },

    onCloseClick: function() {
        this._setFullscreenMode(false);
        this.trigger("preview-data-close");
    },

    onRefreshClick: function() {
        var $tbody = this.$el.find("tbody");
        $tbody.empty();
        this._renderedData = [];
        this.startQueryingForData();
        if (this.model.metaObject.type === metaStoreService.entities.CQ) {
            this.lineChartStore.clearData();
        }
    },

    _setFullscreenMode: function(isInFullscreenMode) {
        this._isInFullscreenMode = isInFullscreenMode;

        this.ui.fullScreen.toggleClass("icon-fullscreen", !this._isInFullscreenMode);
        this.ui.fullScreen.toggleClass("icon-exit-fullscreen", this._isInFullscreenMode);
        var $parentEl = this.$el.parent();
        $parentEl.toggleClass("full-screen", this._isInFullscreenMode);

        if (this._isInFullscreenMode) {
            var height = $parentEl.outerHeight() - this.ui.header.outerHeight() - 16;
            this.ui.tableWrapper.css({
                height: height,
                "max-height": height,
                "min-height": height
            });
        } else {
            this.ui.tableWrapper.removeAttr("style");
        }

        this.trigger("fullscreen-mode", this._isInFullscreenMode);
    },

    onFullScreenClick: function() {
        this._setFullscreenMode(!this._isInFullscreenMode);
        if (this.model.metaObject.type === metaStoreService.entities.CQ) {
            this.renderGraph();
        }
    }
});
